import React from "react";

const Dashboard = React.lazy(() => import("../views/dashboard"));
const Category = React.lazy(() => import("../views/category"));
const Shop = React.lazy(() => import("../views/shop"));
const Register = React.lazy(() => import("../views/pages/register/Register"));
const Product = React.lazy(() => import("../views/product"));
const Customer = React.lazy(() => import("../views/customer"));
const Order = React.lazy(() => import("../views/Order"));


const routes = [
    { path: "/", name: "داشبورد", component: Dashboard },
    { path: "/dashboard", name: "داشبورد", component: Dashboard },
    { path: "/category", name: "گروه محصولات", component: Category },
    { path: "/shop", name: "گروه محصولات", component: Shop },
    { path: "/register", name: "ثبت نام کاربر ", component: Register },
    { path: "/product", name: " محصولات  ", component: Product },
    { path: "/customer", name: " مشتریان", component: Customer },
    { path: "/order", name: " سفارشات فروشگاه", component: Order },

];



export default routes;
